import React from "react";
// 
import Image from "../Reusable/Image";
import loginimg from "../../assets/images/png/studentpanel.png"
const AuthLayout = ({ children }) => {
  return (
    <div>
      <div className="login container">
        <div className="row h-100">
          {/* LEFT LOGIN IMAGE */}
          <div className="col-md-6 m-auto respocollog">
            {/* <div className=""> */}
            <div className=" text-center  d-none d-md-block">
              <div className="position-absolute"><h2 className="Small-Heading fw-600 loginbackground position-relative  text-white text-start">
                A learner's doorway to infinite growth</h2>
              </div>
              <Image src={loginimg} className="w-100 " />
            </div>
            {/* </div> */}
          </div>
          {/* RIGHT SIDE */}
          <div className="col-md-6 m-auto">
            {/* Auth BOX */}
            <div className="login_img" id="btn1">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
